module.exports = __webpack_public_path__ + "static/media/SofiaProSemiBold.a57bde95.otf";